import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../../constants';
import { CreateEventTierDto } from '../../../models/dto';

export interface PriceTierChipProps {
	data: CreateEventTierDto;
}

export const PriceTierChip: FC<PriceTierChipProps> = props => {
	const { data: tier } = props;

	return (
		<Box
			sx={{
				flexShrink: 0,
				backgroundColor: Colors.white_a10,
				p: '4px 8px',
				borderRadius: '100px',
				display: 'flex',
				alignItems: 'center',
				gap: '4px',
			}}
		>
			<Typography
				sx={{
					color: Colors.white,
					fontFamily: 'Montserrat, sans-serif',
					fontSize: '13px',
					fontWeight: '500',
					lineHeight: 1.5,
				}}
			>
				{tier.tierName}
			</Typography>
			<Typography
				sx={{
					color: Colors.white,
					fontFamily: 'Montserrat, sans-serif',
					fontSize: '14px',
					fontWeight: '600',
					lineHeight: 1.12,
				}}
			>
				${Math.floor(tier.priceAmount / 100)}
			</Typography>
		</Box>
	);
};
